// const baseurl = "https://aluempire.gyanouspro.com";
// const baseurl = "http://192.168.1.7:8001";
const baseurl = "https://tubeflexindia.alponix.com";

export { baseurl };


